import api from "../../APIIntercepter";

async function getScheduleDocumentsByScheduleIdAPI(classScheduleId) {
  const res = await api.get("/schedulefile/admin?id=" + classScheduleId);
  return res.data;
}

async function createScheduleDocumentAPI(params) {
  const res = await api.post("/schedulefile/admin", params);
  return res.data;
}

async function updateScheduleDocumentAPI(params) {
  const res = await api.put("/schedulefile/admin", params);
  return res.data;
}

async function deleteScheduleDocumentAPI(documentId) {
  const res = await api.delete("/schedulefile/admin?id=" + documentId);
  return res.data;
}

export {
  getScheduleDocumentsByScheduleIdAPI,
  createScheduleDocumentAPI,
  updateScheduleDocumentAPI,
  deleteScheduleDocumentAPI,
};
